import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import UniversalInputComponent from "../../AdministrativeProcedures/commonComponents/universalInputComponent/UniversalInputComponent";

import { ProgressBar } from "react-loader-spinner";
import TableAppBoatRegRHF from "../../AdministrativeProcedures/commonComponents/tableAppBoatRegRHF/TableAppBoatRegRHF";
import ResultModalWindow from "../../AdministrativeProcedures/commonComponents/ResultModalWindow/ResultModalWindow";

import { SET_BOAT_INFO_BY_REGNUM_STATUS } from "../../../redux/types";

import {
  causersListOptions,
  setOptionsForInputsATETransportAccident,
  setOptionsForInputsUsers,
  setOptionsForBoatTypesFromDictionaries,
  setOptionsForBoatKindsFromDictionaries,
  victimsListOptions,
  getOptionsTransportAccident,
  setGridsByModeTransportAccident,
  setDisabledFieldsByAccidentType,
} from "./transportAccidentFormSettingsRHF";

import {
  clearAccidentData,
  findBoatInfoByRegNum,
  getAccidentInfoById,
  saveTransportAccident,
} from "../../../redux/TransportAccidentsReportReducer/actionsTransportAccidentsReport";

import { getDataTransportAccidentBySearchParams } from "../../../redux/actions";

import {
  API_DOWNLOAD_TRANSPORT_ACCIDENT_FILE,
  MAIN_URL,
  PORT_FOR_REPORT,
} from "../../../constants/constants";

import styles from "./transportAccidentFormRHF.module.css";
import LoaderWithOverlay from "../../GeneralComponents/loaderWithOverlay/loaderWithOverlay";

function TransportAccidentFormRHF() {
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    setError,
    getValues,
    reset,
    setFocus,
  } = useForm({
    mode: "onChange",
    defaultValues: { personType: "individual" },
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { mode } = location.state;
  const fileDownloadApi = MAIN_URL + PORT_FOR_REPORT + API_DOWNLOAD_TRANSPORT_ACCIDENT_FILE;

  const [dataForm, setDataForm] = useState(undefined);
  const [files, setFiles] = useState([]);
  const [buttonType, setButtonType] = useState("");

  const watchIncidentType = watch("incidentType");

  const handleFiles = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFiles((prevFiles) => mergeFileLists(prevFiles, newFiles));
    }
  };

  const handleFileDelete = (fileName) => {
    setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  };

  const mergeFileLists = (prevFiles, newFiles) => {
    const fileMap = new Map();

    prevFiles.forEach((file) => {
      fileMap.set(file.name, file);
    });

    newFiles.forEach((file) => {
      fileMap.set(file.name, file);
    });

    return Array.from(fileMap.values());
  };

  const clearFiles = (e) => {
    setFiles([]);
    e.preventDefault();
  };

  const [showResultModal, setShowResultModal] = useState(false);
  const [textForResultModal, setTextForResultModal] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showCausersListError, setShowCausersListError] = useState(false);
  const [inputsOptions, setInputsOptions] = useState(getOptionsTransportAccident());

  const dictionaryReducer = useSelector((state) => state.dictionaryReducer);

  const { sortedMenuNames } = useSelector((state) => state.roleControllerReducer);
  const { causersList } = useSelector((state) => state.TransportAccidentsReportReducer);
  const { victimsList } = useSelector((state) => state.TransportAccidentsReportReducer);
  const statusBoatInfoByRegNum = useSelector((state) => {
    const { TransportAccidentsReportReducer } = state;
    return TransportAccidentsReportReducer.statusBoatInfoByRegNum;
  });
  const saveStatusTransportAccidents = useSelector((state) => {
    const { TransportAccidentsReportReducer } = state;
    return TransportAccidentsReportReducer.saveError;
  });
  const accidentData = useSelector((state) => {
    const { TransportAccidentsReportReducer } = state;
    return TransportAccidentsReportReducer.newAccidentData;
  });
  const userInfo = useSelector((state) => {
    const { userReducer } = state;
    return userReducer.userInfo;
  });

  const buildCaseAccess = useChapterActionIdMatch(
    sortedMenuNames?.BOAT_INCIDENTS?.formACase?.chapterActionId,
  );

  const findDataByRegNum = () => {
    const data = getValues();
    if (data.boatRegNum !== "" && data.boatRegNum !== undefined) {
      setIsLoading(true);
      // reset({ personType: data.personType });
      // dispatch(clearAccidentData());
      setTimeout(() => dispatch(findBoatInfoByRegNum(data.boatRegNum)), 500);
    }
  };

  const handleSaveButtonClick = (data) => {
    let id = undefined;
    setButtonType(mode);
    for (let item in data) {
      if (data[item] === undefined || data[item] === "") delete data[item];
    }
    if (mode === "edit") {
      const pathArray = window.location.pathname.split("/");
      id = pathArray[pathArray.length - 1];
    }
    if (!data["personType"]) {
      data["personType"] = "individual";
    }
    dispatch(saveTransportAccident(mode, data, causersList, victimsList, id, files));
  };

  const handleFormButtonClick = async () => {
    const pathArray = window.location.pathname.split("/");
    const form = getValues();
    let firstInvalidField = null;
    let errorForm = false;
    let id = undefined;
    id = pathArray[pathArray.length - 1];
    const fields =
      form["personType"] === "individual"
        ? [
            "incidentDate",
            "incidentPlace",
            "incidentReasons",
            "ownerSurname",
            "ownerBirthDate",
            "incidentType",
          ]
        : ["incidentDate", "incidentPlace", "incidentReasons", "ownerLename", "incidentType"];

    fields.forEach((key, index) => {
      if (!errors[key] && !form[key]) {
        setError(key, {
          type: "manual",
          message: "Поле обязательно для формирования дела",
        });
        if (!firstInvalidField) firstInvalidField = key;
      }
    });

    if (Object.keys(errors)?.length) {
      setFocus(Object.keys(errors)[0]);
      errorForm = true;
    }
    if (!causersList || !causersList.length) {
      setShowCausersListError(true);
      errorForm = true;
    }

    if (!errorForm) {
      setButtonType("form");
      dispatch(saveTransportAccident("form", form, causersList, victimsList, id));
    }
  };

  const handleCloseButtonClick = () => {
    navigate("/transportaccidents");
  };

  useEffect(() => {
    if (causersList && causersList.length) {
      setShowCausersListError(false);
    }
  }, [causersList]);

  useEffect(() => {
    switch (statusBoatInfoByRegNum) {
      case "reject": {
        setTextForResultModal("Ошибка! Попробуйте заново или вводите данные вручную!");
        break;
      }
      case "not-found": {
        setTextForResultModal("Данные ненайдены! Вводите вручную!");
        break;
      }
    }
    if (statusBoatInfoByRegNum && statusBoatInfoByRegNum !== "success") {
      setShowResultModal(true);
      setIsLoading(false);
      dispatch({
        type: SET_BOAT_INFO_BY_REGNUM_STATUS,
        data: "",
      });
    }
  }, [statusBoatInfoByRegNum]);

  useEffect(() => {
    if (saveStatusTransportAccidents === "reject") {
      switch (buttonType) {
        case "add": {
          setTextForResultModal("Ошибка созадния транспортного аварийного случая!");
          break;
        }
        case "edit": {
          setTextForResultModal("Ошибка редактирования транспортного аварийного случая!");
          break;
        }
        default:
          setTextForResultModal("Ошибка! Дело транспортного аварийного случая не сформировано!");
      }
      setShowResultModal(true);
    }
    if (saveStatusTransportAccidents === "success") {
      switch (buttonType) {
        case "add": {
          setTextForResultModal("Транспортный аварийный случай создан!");
          break;
        }
        case "edit": {
          setTextForResultModal("Изменения успешно сохранены!");
          break;
        }
        default:
          setTextForResultModal("Дело транспортного аварийного случая сформировано!");
      }
      setShowResultModal(true);
    }
  }, [saveStatusTransportAccidents]);

  useEffect(() => {
    if (
      dictionaryReducer.gimsSections.length > 0 &&
      dictionaryReducer.boatTypes.length > 0 &&
      dictionaryReducer.usersLibrary.length > 0 &&
      dictionaryReducer.kindsBoats.length > 0
    ) {
      setOptionsForInputsATETransportAccident(dictionaryReducer.gimsSections);
      setOptionsForInputsUsers(dictionaryReducer.usersLibrary);
      setOptionsForBoatTypesFromDictionaries(dictionaryReducer.boatTypes);
      setOptionsForBoatKindsFromDictionaries(dictionaryReducer.kindsBoats);
      if (mode === "add") {
        setIsLoading(false);
      }
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    if (Object.keys(accidentData)?.length) {
      const form = getValues();
      if (accidentData.personType === "individual") {
        setInputsOptions(getOptionsTransportAccident(accidentData.personType));
        delete form.ownerLename;
        delete form.ownerLeUnp;
        form.ownerSurname = undefined;
        form.ownerName = undefined;
        form.ownerMidname = undefined;
        form.ownerBirthDate = undefined;
        form.ownerWorkplace = undefined;
      } else {
        delete form.ownerSurname;
        delete form.ownerName;
        delete form.ownerMidname;
        delete form.ownerBirthDate;
        delete form.ownerWorkplace;
        form.ownerLename = undefined;
        form.ownerLeUnp = undefined;
        setInputsOptions(getOptionsTransportAccident(accidentData.personType));
      }

      setDataForm({ ...form, ...accidentData });
      reset({ ...form, ...accidentData });
    }
  }, [accidentData]);

  useEffect(() => {
    if (
      dictionaryReducer.gimsSections.length > 0 &&
      dictionaryReducer.boatTypes.length > 0 &&
      dictionaryReducer.usersLibrary.length > 0 &&
      dictionaryReducer.kindsBoats.length > 0 &&
      Object.keys(accidentData)?.length
    ) {
      setIsLoading(false);
    }
  }, [dictionaryReducer, accidentData]);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "personType" && Object.keys(value)?.length) {
        if (type === "change") {
          if (value[name] === "individual") {
            delete value.ownerLename;
            delete value.ownerLeUnp;
            value.ownerSurname = undefined;
            value.ownerName = undefined;
            value.ownerMidname = undefined;
            value.ownerBirthDate = undefined;
            value.ownerWorkplace = undefined;
            setDataForm({ ...value });
            setInputsOptions(getOptionsTransportAccident(value[name]));
          } else {
            delete value.ownerSurname;
            delete value.ownerName;
            delete value.ownerMidname;
            delete value.ownerBirthDate;
            delete value.ownerWorkplace;
            value.ownerLename = undefined;
            value.ownerLeUnp = undefined;
            setDataForm({ ...value });
            setInputsOptions(getOptionsTransportAccident(value[name]));
          }
        }
      }
    }, "personType");

    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    const fields = ["deadAdult", "deadChildren", "deadDrunk"];
    if (watchIncidentType === 2) {
      fields.forEach((key) => setValue(key, 0));
    }
    if (watchIncidentType === 1) {
      fields.forEach((key) => setValue(key, undefined));
    }
    if (watchIncidentType) {
      setInputsOptions({
        ...inputsOptions,
        footer: { ...setDisabledFieldsByAccidentType(watchIncidentType, fields) },
      });
    }
  }, [watchIncidentType]);

  useEffect(() => {
    if (mode === "add" && userInfo && Object.values(userInfo).length) {
      setDataForm({
        ...dataForm,
        sectionId: userInfo.section.sctId,
        inspectorId: userInfo.userid,
        personType: "individual",
      });
      setValue("sectionId", userInfo.section.sctId);
      setValue("inspectorId", userInfo.userid);
      setValue("personType", "individual");
    }
  }, [userInfo]);

  useEffect(() => {
    if (mode === "view" || mode === "edit") {
      const pathArray = window.location.pathname.split("/");
      const id = pathArray[pathArray.length - 1];
      dispatch(getAccidentInfoById(id));
    }

    setGridsByModeTransportAccident(mode);
    return () => {
      dispatch(clearAccidentData());
    };
  }, []);

  return (
    <div className={styles["content-container"]}>
      <LoaderWithOverlay isLoading={isLoading} />
      <>
        <h2 className={styles["main-text"]}>{`${
          mode === "add" ? "Добавить" : mode === "edit" ? "Редактировать" : "Просмотр"
        } РК аварийного случая`}</h2>
        <form
          className={styles["form-container"]}
          onSubmit={handleSubmit(handleSaveButtonClick)}>
          <UniversalInputComponent
            options={inputsOptions.main}
            mode={mode}
            styles={styles}
            register={register}
            control={control}
            setValue={setValue}
            errors={errors}
            clearErrors={clearErrors}
            handleCustomButton={findDataByRegNum}
            newData={dataForm}
          />
          <div className={styles.gray_background}>
            <TableAppBoatRegRHF
              typeTable={"causersList"}
              tableOptions={causersListOptions}
              mode={mode}
              addAccess={true}
            />
            {showCausersListError && (
              <p className={styles["error-causersList"]}>Необходимо заполнить для формирования дела</p>
            )}
          </div>
          <div className={styles.gray_background}>
            <TableAppBoatRegRHF
              typeTable={"victimsList"}
              tableOptions={victimsListOptions}
              mode={mode}
              addAccess={true}
            />
          </div>
          <UniversalInputComponent
            options={inputsOptions.footer}
            mode={mode}
            styles={styles}
            register={register}
            control={control}
            setValue={setValue}
            errors={errors}
            setError={setError}
            getValues={getValues}
            clearErrors={clearErrors}
            newData={dataForm}
          />
          <>
            {dataForm?.documents?.length > 0 && (
              <>
                <p className={styles["file-description"]}>Прикреплённые файлы</p>
                {dataForm.documents.map((item) => {
                  return (
                    <a
                      className={styles["files-names"]}
                      href={`${fileDownloadApi}${item.docid}`}>
                      {item.docname}
                    </a>
                  );
                })}
              </>
            )}
            {mode !== "view" && (
              <label className={styles["input-file"]}>
                <span className={styles["input-file-btn"]}>Выберите файлы</span>
                <input
                  type="file"
                  name="file"
                  multiple
                  accept={".doc,.docx,.pdf"}
                  onChange={(e) => handleFiles(e)}
                />
                <span
                  className={styles["input-file-text"]}
                  type="text">
                  <span className={styles["file-name"]}>
                    {files.length ? `Количество файлов: ${files.length}` : "Не выбрано"}
                  </span>
                  <div className={styles["icons-block"]}>
                    {files.length > 0 && (
                      <span
                        onClick={(e) => clearFiles(e)}
                        className={styles["delete-icon"]}></span>
                    )}
                    <span className={styles["paperclip"]}></span>
                  </div>
                </span>
              </label>
            )}
          </>
          {Array.from(files).length > 0 && (
            <>
              {Array.from(files).map((item) => {
                return (
                  <p className={styles["files-names"]}>
                    {item.name}
                    <span
                      onClick={() => handleFileDelete(item.name)}
                      className={styles["delete-file-icon"]}></span>
                  </p>
                );
              })}
            </>
          )}
          {mode === "view" && (
            <div className={`${styles.gray_background} ${styles["additional-information"]}`}>
              <div>
                <span>Статус транспортного аварийного случая</span>
                <p className={"fw-bold"}> {dataForm?.incidentStatusName}</p>
              </div>
              {dataForm?.rejectReason && (
                <div>
                  <span>Причина прекращения дела</span>
                  <p>{dataForm?.rejectReason}</p>
                </div>
              )}
            </div>
          )}

          <div className={styles.buttons_container}>
            {mode !== "view" && (
              <>
                <button
                  className={styles.add_button}
                  id={"save"}
                  type={"submit"}>
                  Сохранить
                </button>
                {buildCaseAccess && mode === "edit" && (
                  <button
                    className={styles.save_button}
                    id={"form"}
                    type={"button"}
                    onClick={handleFormButtonClick}>
                    Сформировать дело
                  </button>
                )}
              </>
            )}
            <button
              className={styles.close_button}
              id={"close"}
              type={"button"}
              onClick={(e) => handleCloseButtonClick(e)}>
              Закрыть
            </button>
          </div>
        </form>
        {showResultModal && (
          <ResultModalWindow
            show={showResultModal}
            setShow={setShowResultModal}
            headerTextExternal={textForResultModal}
            result={saveStatusTransportAccidents}
            handleCloseApp={() => {
              if (saveStatusTransportAccidents !== "reject") navigate("/transportaccidents");
              if (statusBoatInfoByRegNum && statusBoatInfoByRegNum !== "success") {
                setShowResultModal(false);
              }
            }}
          />
        )}
      </>
      {/*)}*/}
    </div>
  );
}

export default TransportAccidentFormRHF;
